import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type DeleteClubParams = {
  profileId: string;
} & RequestConfig;

export const deleteClubProfile = async ({
  profileId,
  config
}: DeleteClubParams) =>
  api.delete<void>(`/api/ClubProfile/${profileId}`, config);
